<template>
  <form class="card-registration-form">
    <div class="form-title">{{ $t('cards.registerTitle') }}</div>
    <label class="input-label" for="number">
      <input id="number" name="number" type="text" placeholder="Number" v-model="number" :class="{ 'not-valid': numberNotValid, 'valid': !numberNotValid}">
      <span :class="{ 'number-error validation-error': true, 'show-error': numberNotValid }">{{ $t('cards.registration.numberNotValid') }}</span>
    </label>
    <label class="input-label" for="pin">
      <input id="pin" name="pin" type="text" placeholder="PIN" v-model="pin" :class="{ 'not-valid': pinNotValid, 'valid': !pinNotValid}">
      <span :class="{ 'pin-error validation-error': true, 'show-error': pinNotValid }">{{ $t('cards.registration.pinNotValid') }}</span>
    </label>
    <button type="button" class="btn-register button btn-with-icon" @click="registerCard">{{ $t('cards.buttons.registerNewCard') }} <img src="@/assets/svgs/2024/icons/arrow-big.svg"></button>
    <loading :active.sync="isLoading" is-full-page></loading>
  </form>
</template>

<script>
import Loading from 'vue-loading-overlay';

export default {
  name: 'CardRegistration',
  components: {
    Loading
  },
  data() {
    return {
      number: '',
      pin: '',
      numberNotValid: false,
      pinNotValid: false,
      isLoading: false
    }
  },
  watch: {
    number(number) {
      //if (number.match(/[0-9]{8,}/) && number.length <= 10) {
      if (number.match(/[0-9]{1,}/) && number.length <= 10) {
        this.numberNotValid = false
      } else {
        this.numberNotValid = true
      }
    },
    pin(pin) {
      if (pin.match(/[0-9a-zA-Z]{4,}/g) && pin.length <= 25) {
        this.pinNotValid = false
      } else {
        this.pinNotValid = true
      }
    }
  },
  methods: {
    registerCard() {
      if (!this.numberNotValid && !this.pinNotValid) {
        this.isLoading = true
        this.$store.dispatch('registerCard', {cardNumber: this.number, cardPin: this.pin})
            .then((result) => {
              if (result === 'REGISTERED_CARD') {
                this.isLoading = false
                this.$notify({
                  group: 'registration',
                  text: this.$t('cards.registration.addSuccess')
                })
                this.$router.push({name: 'my-card'})
              }
            })
            .catch((err) => {
              console.log('register card error');
              this.isLoading = false
              if (err === 'DUPLICATE') {
                this.$notify({
                  group: 'registration',
                  text: this.$t('cards.registration.registrationFailedDuplicate'),
                  duration: 5000
                })
                return
              }
              if (err === 'SERVICE_ERROR') {
                this.$notify({
                  group: 'registration',
                  text: this.$t('cards.registration.serviceError')
                })
                return
              }

              // got an error from the api
              if (typeof err === 'object') {
                console.log(err)
                this.$notify({
                  group: 'registration',
                  text: this.$t('cards.registration.invalidCredentials')
                })
                return
              }
            })
      }
    }
  }
}
</script>

<style lang="scss">
@import '~vue-loading-overlay/dist/vue-loading.css';

.card-registration-form {
  max-width: rem-calc(380px);
  margin: 0 auto;
  background: $light-gray;
  padding: 2.5rem 2rem;

  .form-title {
    margin-bottom: 2rem;
    text-align: center;
    font-weight: bold;
  }

  .input-label {
    input {
      border: none;
      border-radius: 100px;
      background-color: $white;
      padding: 1.9rem;
      font-size: 0.9rem;
      box-shadow: none;

      &::placeholder {
        color: $dark-gray;
      }

      &.not-valid {
        color: get-color(alert);
        &::placeholder {
          color: get-color(alert);
        }
      }
    }

    .validation-error {
      display: block;
      text-align: right;
      font-size: rem-calc(12);

      visibility: hidden;
      opacity: 0;
      transform: translate(0, 100%);
      transition: all .2s ease-in-out;

      &.show-error {
        visibility: visible;
        opacity: 1;
        transform: translate(0, 0);
      }
    }
  }

  .btn-register.btn-with-icon {
    margin: 0 auto;
    width: 100%;
    /*border-radius: 20rem;
    box-shadow: 0px 1px 2px rgba($black, .15);*/
    background: $light-gray;

    &:hover {
      border-color: $dark-gray;
      background-color: $white;
    }
  }
}
</style>
